
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqa_45SDk4bD0m7SkThd3hGGVqB0aBlwXfeFy3GEiYwZPksMeta } from "/codebuild/output/src4220147612/src/src/pages/faq.vue?macro=true";
import { default as menuPPeRvUDkxLdD73uMRcveKQWXlNCqz77ZwZ4_45Ma_45Fl0IMeta } from "/codebuild/output/src4220147612/src/src/pages/menu.vue?macro=true";
import { default as indexxEwQUlMuKIp_wcGVmraeD32GMsufoAFQYvobA4g2lWEMeta } from "/codebuild/output/src4220147612/src/src/pages/index.vue?macro=true";
import { default as contactiAVDebwzNEkmlQ5sbxnENfUzp0KMXdTMoeNxgNH9d_sMeta } from "/codebuild/output/src4220147612/src/src/pages/contact.vue?macro=true";
import { default as tutorialtqmzOLefyVhGDxTMCfJ_45wKTYMh6Ev80VI_45uY78qlQuEMeta } from "/codebuild/output/src4220147612/src/src/pages/tutorial.vue?macro=true";
import { default as agreementjLf_gs5P3FL_45c_45ILiOIbF9D6H52ch_45OL9PQO2bXeHo4Meta } from "/codebuild/output/src4220147612/src/src/pages/agreement.vue?macro=true";
import { default as about_45passyUvtdRk2v2FSSdN_453ZUm4ECoklTOdH1X03NENkyTEDQMeta } from "/codebuild/output/src4220147612/src/src/pages/about-pass.vue?macro=true";
import { default as index7x8_PpKButgpXd_45_45AZopkXQ2EyTyEM6gjqJeVafTyegMeta } from "/codebuild/output/src4220147612/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93_45J53CsfSwN_45CBX2bEsgZ8Y_bg2J9RDjkf_B22xLYo3YMeta } from "/codebuild/output/src4220147612/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceAtoF2Nrp0AQC92Nh8TWxv58epuA9vb27ozNhPJ4gtpUMeta } from "/codebuild/output/src4220147612/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93rjiLf0OkDF9H5lmtRPZ4sEkELPflnJ1vPeWHQkglBoEMeta } from "/codebuild/output/src4220147612/src/src/pages/notice/[id].vue?macro=true";
import { default as index3pX_Arp4TWSFTfifLwKBfdDvEe_45rNf_RvkW6YM504rUMeta } from "/codebuild/output/src4220147612/src/src/pages/coupon/index.vue?macro=true";
import { default as indexeHNVnv4akUNCZb0LANJwa2dVauVaouDw0n0YgDHcSjsMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/index.vue?macro=true";
import { default as indexDMUgG5EjlNRrfplImO2vHG0aIYC4DJnhFLK_dNeCFhMMeta } from "/codebuild/output/src4220147612/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93z4XO6LaMz3Nw7TdlzPGMbGPm2Z38b0g8dEcWLX17paUMeta } from "/codebuild/output/src4220147612/src/src/pages/parking/[id].vue?macro=true";
import { default as index4nI_45hqCup2Sd2eJ_45VXiypRVSIUeER7LAb2VQpaBl40QMeta } from "/codebuild/output/src4220147612/src/src/pages/history/index.vue?macro=true";
import { default as indexHITi9ajHUrSO5rmfA5OQwuFmOg5vR1WTSHrjEHDRJSYMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/index.vue?macro=true";
import { default as index6Mibe_45xshqBHfR5_45InjsVDhZsJXzodBp5JE6htqWifEMeta } from "/codebuild/output/src4220147612/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexSJAcCBeqn8NBx2I32ZmkY_45fZCe46VU_45_a0lNNCkQk5MMeta } from "/codebuild/output/src4220147612/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviFhjXf7uCrzAPgE3_O3dlU9qyye52bAx9V_455mDovNBiAMeta } from "/codebuild/output/src4220147612/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edithLzOJVCkLqxGZ2SLu5aULx5jrlrJjlG9_l25U1lSfSEMeta } from "/codebuild/output/src4220147612/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementBB1W8wHzMjPbP1Ql5ZnveCMPKGy2RFmzz4Vz0N5wne8Meta } from "/codebuild/output/src4220147612/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexMBRbgvVPMLy8fDo7EnkTMt29BoFRX5nOZ1bIpoAioLoMeta } from "/codebuild/output/src4220147612/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dJcCGBtB61BP9SGWbV0M7qyghXMGhbqozaTdrn_45T2OL4Meta } from "/codebuild/output/src4220147612/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm37ftmcpI9CmrgpmuEhjxMmxz8z9OeAjT_qbFqbOP8JEMeta } from "/codebuild/output/src4220147612/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index25mrE0pF9rTfPD8Ao2qKre2JrSb1s95GjGfX67nwPJ0Meta } from "/codebuild/output/src4220147612/src/src/pages/card/create/index.vue?macro=true";
import { default as indexO_AFN2T04U8kbeMepzifD2TOkfWSIRyFFoV3TokEjisMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmOPKp3_45bWebUh7jErUDqDQtXW2mWhSMWX3SYdNMDEIfwMeta } from "/codebuild/output/src4220147612/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmIWXoqHK6ywujAwzHWTiiNGf3PNxXHplprer2SGubaQYMeta } from "/codebuild/output/src4220147612/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete9KiOFZdeu7aHfjR43JTZwD0lp5ct9KNVmik02z12rKsMeta } from "/codebuild/output/src4220147612/src/src/pages/membership/complete.vue?macro=true";
import { default as registergwXmp13eq3EsDXEvL_45_45PiqPdVmpMnvQSKVWJxO_45X5C0Meta } from "/codebuild/output/src4220147612/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93ejI_45TbGpGu3RNpGR5mNFpy84sgVWGRh0Q_joVqrktZcMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmAObpIL7wkqgxi7pKjY_451B8fOjnCB9608uVD_45hwikEwEMeta } from "/codebuild/output/src4220147612/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_930uk1mL2if9Xp_45HUs5u81nXbQ0u_cpcdX98teb6CJbYAMeta } from "/codebuild/output/src4220147612/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indextF43GQY0njYeVK2soHRcnntF375IdRRJUSsWas6I5ZUMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeLPrB9KP1Rb5ybY0AhGJtEqbRFYhlV2X5ZpPTnZFPd4sMeta } from "/codebuild/output/src4220147612/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeTD3TNvVXPOtudtjJxMs5i4eTLBXPt1gXQwP8_45BoHWcsMeta } from "/codebuild/output/src4220147612/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completesJHCdTc6q08p9zn9n_45ESZ9uD_qd6McApcuwuNLljLTwMeta } from "/codebuild/output/src4220147612/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerhKxndpUsdYkRxVwpneTQQxqza06pwDFbijlkPpquSYsMeta } from "/codebuild/output/src4220147612/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeBiUWFR_5HRfcqudAkOl_mJ357cJM0CSn77sfY6ILgFgMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexqejvF17pDiTdS7pA_45Eix4ZH8AvF0qaExBm62EmcsFsIMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmvC_07pYC_45Fy5ks000LEX_45aa83n_0XeK0OcCeMsq0gRUMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeaBT2ceBHTqDeegwXJKC0VHHpLxAqThW8ERBKWl9Io3oMeta } from "/codebuild/output/src4220147612/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexoxBJc2wJkFNl2AE0o6AxgURc2zg4F_45PZNKy5_45TD46h4Meta } from "/codebuild/output/src4220147612/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_935NdCC0VwBpq_45s0tGY8iDGTHNUTKyGBnh_AcgDszSKgQMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeF4A5L015ZT9FblqZP5jCh1iCU0jJS85iY3EUaRJQLO0Meta } from "/codebuild/output/src4220147612/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasnO_iBKP_8T5u19pju5kauZrFMZoazewUZG8i7Tm1edoMeta } from "/codebuild/output/src4220147612/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample7HxUCxhwLCwk1UoH_45LzaWfryCIQ6uivK8RMtrqbDJ4MMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailIm_h_45Hb5n0q_2pB_45lqpKsN0TRzYHn55ifRj9MCty1EUMeta } from "/codebuild/output/src4220147612/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmyEySX8ABLddNxe7tZi39fJq8Ukx7UesnLY1NBxXzRxAMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent_459s6zV2fhqu_45xzEpoCvIXTmFZoLKDFGQBgmTEvkS5a4Meta } from "/codebuild/output/src4220147612/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmqqDqjjnPC8U_45KreJD2FI1KtZz6D8vBYFhvl7rIaNiZgMeta } from "/codebuild/output/src4220147612/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateISdjX26oyelzm2nhwPY2gUJF8uLpkcnU33kLORcOessMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeTgG8Ol56bfur6us3soIjcoFOvIYGDy5Ju81zNtH2LgUMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code5jvBV52nWobF9g82EpUaCO33pBfeQux0t_of16F11SQMeta } from "/codebuild/output/src4220147612/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordaNI951p4AWy_45Pqm_4rZ0bapVDfXLJRx4zQtRjw2ZaOMMeta } from "/codebuild/output/src4220147612/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias37dC4ReQ3PhggLUBG_G_01YOG3MUnJeoOT9w4iaUgFUMeta } from "/codebuild/output/src4220147612/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerfoGdAn6KM5spv58kVwh_tfCAM_45PNtTh1B0K4EUy8yB8Meta } from "/codebuild/output/src4220147612/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeyl7X_45m06JUNB2CU98_Xqfivk_45fMDmrEyZoLN0o_45StCQMeta } from "/codebuild/output/src4220147612/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index6vB3bfHGiFqM_IIcFMM9VabJh15T92mAG3CNZF96hUkMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexuref0P0zwzBiZytI04xGO2ynbhhkX9vlv4c65EJVYrEMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexDb_q535MMtvO5oq9SItArTHZqPLadXuCNnK44Ey6WkAMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexE4r6s0GDOW_45gLV1CBw3wrgufkDAWJI_Aj_ERps_r6yYMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updaterP_45b9HvELLlzeS7OGiYCgvO6i1nfJlLybeEqUI6UzTQMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeFTEPgOM8k2jCgd95Xv2tvMXntVBOHW4SwtfI5UogfqQMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm4ahZeGruHj_qIElXpFaP7_yRvkmxBNFwDnzTgViRuYUMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index7viImSSTnjnhG12Ao4sSB8uDKQJzHwajUQgYquN_BfUMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completetjsqYE8yehmfGlX8Co0HYrKuxUlxpC3hzhfONbwGBF4Meta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateXMbMNt1nILxBvF4zWJ3mGhT8fSAE_KpN94NfXPB_mrQMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexQkrtElaV_456vGDtLgRGOgBeJRjizVcpbbtziydR_JUvcMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexUm18wB7vvjY2PK8lirSW9PwdQXAkWz6ZJv6fcYCnLxQMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeH7cXpCKmIQ3hErMHNZ_456_LXSq51kfqzaX7UmqzTiIEkMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexv7101c18K17e1hzqInXkC5GfAr3CBfe7AWTSSzxOW6cMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codebtZrYBUafugym11RzyBBhbPdOTKWK6wHqrXTbdAKZzoMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexENs00i9xJoiHmdamwzKbVX5nBV525U_ldu9pYASOL1oMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexNnU1vfDMP7Rs6bmgq0iJg1lTp834H598tcpBNZC3MP0Meta } from "/codebuild/output/src4220147612/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexIZgUqWygBuCpz6FouPkW7dkVtfzqXZwuBwMgRDPI7rEMeta } from "/codebuild/output/src4220147612/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatefULcgaCC3PGwM62eJNbt2ONfOoC3dmXwXVcfookOK58Meta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmzymilqjoYAoprTSLWy79O0vwJRcog1flf62RU4l8S_45kMeta } from "/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuPPeRvUDkxLdD73uMRcveKQWXlNCqz77ZwZ4_45Ma_45Fl0IMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexxEwQUlMuKIp_wcGVmraeD32GMsufoAFQYvobA4g2lWEMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index3pX_Arp4TWSFTfifLwKBfdDvEe_45rNf_RvkW6YM504rUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index4nI_45hqCup2Sd2eJ_45VXiypRVSIUeER7LAb2VQpaBl40QMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index6Mibe_45xshqBHfR5_45InjsVDhZsJXzodBp5JE6htqWifEMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexSJAcCBeqn8NBx2I32ZmkY_45fZCe46VU_45_a0lNNCkQk5MMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index25mrE0pF9rTfPD8Ao2qKre2JrSb1s95GjGfX67nwPJ0Meta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmOPKp3_45bWebUh7jErUDqDQtXW2mWhSMWX3SYdNMDEIfwMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmIWXoqHK6ywujAwzHWTiiNGf3PNxXHplprer2SGubaQYMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete9KiOFZdeu7aHfjR43JTZwD0lp5ct9KNVmik02z12rKsMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registergwXmp13eq3EsDXEvL_45_45PiqPdVmpMnvQSKVWJxO_45X5C0Meta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmAObpIL7wkqgxi7pKjY_451B8fOjnCB9608uVD_45hwikEwEMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeLPrB9KP1Rb5ybY0AhGJtEqbRFYhlV2X5ZpPTnZFPd4sMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeTD3TNvVXPOtudtjJxMs5i4eTLBXPt1gXQwP8_45BoHWcsMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completesJHCdTc6q08p9zn9n_45ESZ9uD_qd6McApcuwuNLljLTwMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerhKxndpUsdYkRxVwpneTQQxqza06pwDFbijlkPpquSYsMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmvC_07pYC_45Fy5ks000LEX_45aa83n_0XeK0OcCeMsq0gRUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeaBT2ceBHTqDeegwXJKC0VHHpLxAqThW8ERBKWl9Io3oMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexoxBJc2wJkFNl2AE0o6AxgURc2zg4F_45PZNKy5_45TD46h4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeF4A5L015ZT9FblqZP5jCh1iCU0jJS85iY3EUaRJQLO0Meta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample7HxUCxhwLCwk1UoH_45LzaWfryCIQ6uivK8RMtrqbDJ4MMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailIm_h_45Hb5n0q_2pB_45lqpKsN0TRzYHn55ifRj9MCty1EUMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmyEySX8ABLddNxe7tZi39fJq8Ukx7UesnLY1NBxXzRxAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent_459s6zV2fhqu_45xzEpoCvIXTmFZoLKDFGQBgmTEvkS5a4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmqqDqjjnPC8U_45KreJD2FI1KtZz6D8vBYFhvl7rIaNiZgMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeTgG8Ol56bfur6us3soIjcoFOvIYGDy5Ju81zNtH2LgUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code5jvBV52nWobF9g82EpUaCO33pBfeQux0t_of16F11SQMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordaNI951p4AWy_45Pqm_4rZ0bapVDfXLJRx4zQtRjw2ZaOMMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerfoGdAn6KM5spv58kVwh_tfCAM_45PNtTh1B0K4EUy8yB8Meta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeyl7X_45m06JUNB2CU98_Xqfivk_45fMDmrEyZoLN0o_45StCQMeta || {},
    component: () => import("/codebuild/output/src4220147612/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4220147612/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]